import apiService from './apiService';

const POLLING_INTERVAL = 60000; // 1 minuto
let pollingInterval = null;

const rateLimitService = {
  /**
   * Starts polling for rate limits
   */
  startPolling: () => {
    if (pollingInterval) return; // Ya está corriendo

    // Hacer la primera llamada inmediatamente
    rateLimitService.fetchRateLimits();

    // Configurar el polling
    pollingInterval = setInterval(() => {
      rateLimitService.fetchRateLimits();
    }, POLLING_INTERVAL);
  },

  /**
   * Stops polling for rate limits
   */
  stopPolling: () => {
    if (pollingInterval) {
      clearInterval(pollingInterval);
      pollingInterval = null;
    }
  },

  /**
   * Fetches current rate limits from the API
   */
  fetchRateLimits: async () => {
    try {
      const response = await apiService.get('api/RateLimit');
      apiService.updateRateLimits({
        'x-minute-requests-left': response.minuteRequestsLeft.toString(),
        'x-hourly-requests-left': response.hourlyRequestsLeft.toString(),
        'x-daily-requests-left': response.dailyRequestsLeft.toString()
      });
    } catch (error) {
      console.error('Error fetching rate limits:', error);
    }
  },

  /**
   * Gets the current Apollo API rate limit information
   * @returns {Object} The rate limit information
   */
  getRateLimitInfo: () => {
    const rateLimits = apiService.getCurrentRateLimits();
    return {
      dailyRequestsLeft: parseInt(rateLimits['x-daily-requests-left']) || 0,
      dailyUsage: parseInt(rateLimits['x-daily-usage']) || 0,
      hourlyRequestsLeft: parseInt(rateLimits['x-hourly-requests-left']) || 0,
      hourlyUsage: parseInt(rateLimits['x-hourly-usage']) || 0,
      minuteRequestsLeft: parseInt(rateLimits['x-minute-requests-left']) || 0,
      minuteUsage: parseInt(rateLimits['x-minute-usage']) || 0,
      rateLimitDaily: parseInt(rateLimits['x-rate-limit-daily']) || 0,
      rateLimitHourly: parseInt(rateLimits['x-rate-limit-hourly']) || 0,
      rateLimitMinute: parseInt(rateLimits['x-rate-limit-minute']) || 0
    };
  },

  /**
   * Checks if we are close to hitting any rate limits
   * @returns {Object} Object containing warning flags for each limit type
   */
  checkRateLimitWarnings: () => {
    const limits = rateLimitService.getRateLimitInfo();
    const WARNING_THRESHOLD = 0.1; // 10% remaining

    return {
      dailyWarning: (limits.dailyRequestsLeft / limits.rateLimitDaily) <= WARNING_THRESHOLD,
      hourlyWarning: (limits.hourlyRequestsLeft / limits.rateLimitHourly) <= WARNING_THRESHOLD,
      minuteWarning: (limits.minuteRequestsLeft / limits.rateLimitMinute) <= WARNING_THRESHOLD
    };
  }
};

export default rateLimitService; 